const Utility = {
  namespaced: true,
  state: {
    header: {
      e: null,
      image: null,
      title: null,
      excerpt: null
    },
    e: null,
    s: null
  },
  mutations: {
    SET_MERCHANT: (state, data) => {
      state.s = data;
    },
    SET_EVENT: (state, data) => {
      state.e = data;
    },
    SET_TITLE: (state, title) => {
      state.header.title = title;
    },
    SET_EXCERPT: (state, excerpt) => {
      state.header.excerpt = excerpt;
    },
    SET_IMAGE: (state, image) => {
      state.header.image = image;
    },
    SET_ACTION: (state, action) => {
      state.header.action = action;
    },
    SET_EVENT_SLUG: (state, data) => {
      state.header.e = data;
    }
  },
  actions: {
    setHeader({ commit }, data) {
      commit("SET_EVENT_SLUG", data.slug);
      commit("SET_TITLE", data.title);
      commit("SET_EXCERPT", data.excerpt);
      commit("SET_IMAGE", data.image);
      commit("SET_ACTION", data.action);
    },
    setMerchant({ commit }, data) {
      commit("SET_MERCHANT", data);
      return true;
    },
    setEvent({ commit }, data) {
      commit("SET_EVENT", data);
      return true;
    },
    logout({ commit }, data) {
      commit("SET_EVENT", null);
      commit("SET_MERCHANT", null);
      commit("SET_TITLE", null);
      commit("SET_EXCERPT", null);
      commit("SET_IMAGE", null);
      commit("SET_ACTION", null);
      return true;
    }
  }
};

export default Utility;
